export const VISION_PANEL_ACTIONS = {
	IS_SHOW_PANEL:    'IS_SHOW_PANEL',
	SITE_BACKGROUND:  'SITE_BACKGROUND',
	IS_IMG:           'IS_IMG',
	SET_FONT_SIZE:    'SET_FONT_SIZE',
	SET_FONT_KERNING: 'SET_FONT_KERNING',
}
